import React from 'react';
import { Button as AntdButton, ButtonProps } from 'antd';
import { ConfigProvider } from 'antd';
import { Color } from '@/utils/constants';
import { cn } from '@/utils/common';
import styles from './Styles.module.scss';

export const Button: React.FC<ButtonProps> = ({
  children,
  className,
  size = 'large',
  htmlType = 'submit',
  type = 'primary',
  color = Color.Primary,
  ...props
}) => {
  const theme = {
    token: {
      colorPrimary: color,
    },
    components: {
      Button: {
        colorPrimary: color,
      },
    },
  };
  return (
    <ConfigProvider theme={theme}>
      <AntdButton
        {...props}
        size={size}
        type={type}
        htmlType={htmlType}
        className={cn(
          'flex items-center justify-center font-medium',
          className,
          styles.btnIcon,
        )}
      >
        {children}
      </AntdButton>
    </ConfigProvider>
  );
};
export default Button;
